<script>
	import { onDestroy, onMount } from "svelte";
	import { lang } from "./lib/stores";
	import Title from "./components/Title.svelte";
	import Intro from "./components/Intro.svelte";
	import Chapter1 from "./components/Chapter1.svelte";
	import Chapter2 from "./components/Chapter2.svelte";
  import Chapter3 from "./components/Chapter3.svelte";
  import Chapter4 from "./components/Chapter4.svelte";
	import Footer from './components/Footer.svelte';

	const source = "/data/data.json";
	let selectedLang;

	const unsubscribe = lang.subscribe((value) => selectedLang = value);

	onDestroy(unsubscribe);

	let loading = true;
	let error = false;
	let data = {};

	const getData = async (source) => {
		try {
			const response = await fetch(source);
			if (response.ok) {
				data = await response.json();
			} else {
				error = true;
				console.error(`Response status: ${response.status}`);
			}
			loading = false;
		} catch (e) {
			console.error(e);
		}
	};

	onMount(async () => {
		getData(source);

		const params = new Proxy(new URLSearchParams(window.location.search), {
  		get: (searchParams, prop) => searchParams.get(prop),
		});
		let newLang = params.lang.toLowerCase();
		lang.update(() => newLang);
	});

	$: data = {};
</script>
<section class="app {selectedLang}">
	<Intro />
	{#if error}
		<div class="loading">
			<h2>
				Si è verificato un errore nel caricamento dei dati, per favore
				riprova più tardi.
			</h2>
		</div>
	{:else if loading}
		<div class="loading">
			<h2>Sto caricando i dati, mi serve un attimo di pazienza...</h2>
		</div>
	{:else}
		<div class="app__chapters">
			<Title
				chapter="1"
				title={selectedLang === 'it' ? "Il Vocabolario" : "The Vocabulary"}
				subtitle={selectedLang === 'it' ? "Ovvero: quali parole usa Ghali" : "Or: What Words does Ghali use?"}
				color="2"
			/>
			<div class="chapter"><Chapter1 {data} /></div>
			<Title
				chapter="2"
				title={selectedLang === 'it' ? "I temi" : "The Themes"}
				subtitle={selectedLang === 'it' ? "Ovvero: quali parole usa Ghali per raccontare la sua vita" : "Or: Which Words does Ghali use to Talk about his Life?"}
				color="1"
			/>
			<div class="chapter"><Chapter2 {data} /></div>
			<Title
				chapter="3"
				title={selectedLang === 'it' ? "La mappa" : "The Map"}
				subtitle={selectedLang === 'it' ? "Ovvero: i luoghi di Ghali" : "Or: Ghali's Places"}
				color="3"
			/>
			<div class="chapter"><Chapter3 {data} /></div>
			<Title
				chapter="4"
				title={selectedLang === 'it' ? "Il metodo" : "The Method"}
				subtitle={selectedLang === 'it' ? "Ovvero: cosa abbiamo usato per creare questo sito" : "Or: How Did We Create this Site"}
				color="2"
			/>
			<div class="chapter"><Chapter4 {data} /></div>
		</div>
	{/if}
	<Footer />
</section>
<div class="svgDef">
	<svg with="0" height="0" viewBox="0 0 0 0">
		<defs>
			<pattern
				id="chevron-accent-1"
				patternUnits="userSpaceOnUse"
				width="20"
				height="20"
				patternTransform="scale(.2) rotate(0)"
			>
				<path
					d="M-5 5L5.1 15 15 5l10 10"
					stroke-linejoin="round"
					stroke-linecap="round"
					stroke-width="2.5"
					stroke="black"
					fill="none"
					style="stroke: var(--accent-1d);"
				/>
			</pattern>
			<pattern
				id="chevron-accent-2"
				patternUnits="userSpaceOnUse"
				width="20"
				height="20"
				patternTransform="scale(.2) rotate(0)"
			>
				<path
					d="M-5 5L5.1 15 15 5l10 10"
					stroke-linejoin="round"
					stroke-linecap="round"
					stroke-width="2.5"
					stroke="black"
					fill="none"
					style="stroke: var(--accent-2);"
				/>
			</pattern>
			<pattern
				id="chevron-accent-3"
				patternUnits="userSpaceOnUse"
				width="20"
				height="20"
				patternTransform="scale(.2) rotate(0)"
			>
				<path
					d="M-5 5L5.1 15 15 5l10 10"
					stroke-linejoin="round"
					stroke-linecap="round"
					stroke-width="2.5"
					stroke="black"
					fill="none"
					style="stroke: var(--accent-3);"
				/>
			</pattern>

			<pattern
				id="dots-accent-1"
				patternUnits="userSpaceOnUse"
				width="15"
				height="15"
				patternTransform="scale(.25) rotate(45)"
			>
				<path
					d="M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5"
					stroke-width="1"
					stroke="none"
					fill="black"
					style="fill: var(--accent-1d);"
				/>
			</pattern>
			<pattern
				id="dots-accent-2"
				patternUnits="userSpaceOnUse"
				width="15"
				height="15"
				patternTransform="scale(.25) rotate(45)"
			>
				<path
					d="M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5"
					stroke-width="1"
					stroke="none"
					fill="black"
					style="fill: var(--accent-2);"
				/>
			</pattern>
			<pattern
				id="dots-accent-3"
				patternUnits="userSpaceOnUse"
				width="15"
				height="15"
				patternTransform="scale(.25) rotate(45)"
			>
				<path
					d="M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5"
					stroke-width="1"
					stroke="none"
					fill="black"
					style="fill: var(--accent-3);"
				/>
			</pattern>
			<pattern
				id="dots-grey-0"
				patternUnits="userSpaceOnUse"
				width="15"
				height="15"
				patternTransform="scale(.25) rotate(45)"
			>
				<path
					d="M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5"
					stroke-width="1"
					stroke="none"
					fill="black"
					style="fill: var(--grey-0);"
				/>
			</pattern>
			<pattern
				id="dots-grey-1"
				patternUnits="userSpaceOnUse"
				width="15"
				height="15"
				patternTransform="scale(.25) rotate(45)"
			>
				<path
					d="M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5"
					stroke-width="1"
					stroke="none"
					fill="black"
					style="fill: var(--grey-1);"
				/>
			</pattern>
			<pattern
				id="dots-grey-2"
				patternUnits="userSpaceOnUse"
				width="15"
				height="15"
				patternTransform="scale(.25) rotate(45)"
			>
				<path
					d="M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5"
					stroke-width="1"
					stroke="none"
					fill="black"
					style="fill: var(--grey-2);"
				/>
			</pattern>
			<pattern
				id="dots-grey-3"
				patternUnits="userSpaceOnUse"
				width="15"
				height="15"
				patternTransform="scale(.25) rotate(45)"
			>
				<path
					d="M11 6a5 5 0 01-5 5 5 5 0 01-5-5 5 5 0 015-5 5 5 0 015 5"
					stroke-width="1"
					stroke="none"
					fill="black"
					style="fill: var(--grey-3);"
				/>
			</pattern>
		</defs>
	</svg>
</div>
<style>
	.app__chapters {
		display: block;
		position: relative;
	}
	.loading {
		align-content: center;
		align-items: center;
		background: var(--accent-1);
		display: flex;
		height: 50vh;
		justify-content: center;
		margin: 0;
		scroll-snap-type: y proximity;
		text-align: center;
		width: 100%;
	}

	.loading h2 {
		max-width: 60vw;
	}
</style>
